import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { RoleApi } from 'api';

function useGetAllScopes() {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ scope: 'all' }),
    () => RoleApi.getAllScopes(),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAllScopes;
